import SubTabs from 'components/sub-tabs';
import React from 'react';
import { useIntl } from 'react-intl';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

enum Tabs {
  ACTIVE = 'active',
  HARVESTED = 'harvested',
  OTHERS = 'others',
}

const SitesSubTabs: React.FC<Props> = () => {
  const intl = useIntl();
  return (
    <SubTabs
      tabs={[
        {
          label: intl.formatMessage({ id: 'planningPrognosis.tabs.activeSite' }),
          value: Tabs.ACTIVE,
        },
        {
          label: intl.formatMessage({ id: 'planningPrognosis.tabs.harvested' }),
          value: Tabs.HARVESTED,
        },
        {
          label: intl.formatMessage({ id: 'planningPrognosis.tabs.other' }),
          value: Tabs.OTHERS,
        },
      ]}
    />
  );
};

export default React.memo(SitesSubTabs);
